import { SymbolRender } from "@visactor/vrender-core/render/symbol";

import { resolveContainerBinding } from "../../../common/explicit-binding";

import { MathPickerContribution, MathSymbolPicker } from "../constants";

import { DefaultMathSymbolPicker } from "./symbol-picker";

let loadSymbolPick = !1;

export function bindSymbolMathPickerContribution(container) {
    loadSymbolPick || (loadSymbolPick = !0, container.bind(MathSymbolPicker).toDynamicValue((() => new DefaultMathSymbolPicker(resolveContainerBinding(container, SymbolRender)))).inSingletonScope(), 
    container.bind(MathPickerContribution).toService(MathSymbolPicker));
}
//# sourceMappingURL=symbol-module.js.map
